"use client"
import { useState, useEffect } from "react";
import { useUserInfoStore } from "@/models/userInfo";

async function getWeather(zip: string) {
    const weather = await fetch(`/api/weather/new-weather-detail?zip=${zip}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    const { data } = await weather.json();
    return data;
}
const Weather = () => {
    const [loading, setLoading] = useState(true);
    const [weather, setWeather] = useState<any>(null);
    const { userLocation } = useUserInfoStore();
    useEffect(() => {
        if (userLocation?.zip || userLocation?.postalCode) {
            getWeather(userLocation?.zip || userLocation?.postalCode!).then((res) => {
                setWeather(res);
                setLoading(false);
            })
        }
    }, [userLocation]);

    return (
        <>
            {loading ? <div className="w-full h-full flex items-center justify-center"></div> : (
                <div className="flex items-center justify-center px-2">
                    <div className="mr-2">
                        {weather?.icon ? <img src={weather?.icon} alt="weather" className="w-16 h-16 min-w-16 min-h-16" /> : <div className="w-16 h-16 bg-gray-200 rounded-full" />}
                    </div>
                    <div className="flex-1">
                        <div className="text-black font-bold text-xs">{weather?.condition}</div>
                        <div className="text-2xl font-bold">{weather?.temperature}°F</div>
                        <div className="text-xs text-gray-500 flex items-center">
                            <span className="mr-2">{weather?.temperature_min}°/{weather?.temperature_max}° </span>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Weather;